import Control from "../../common/Control";

const OrganizationSelector = ({ availableOrganizations, value, onChange }) => {
  return (
    <div className="mb-4 p-3 rounded" style={{ background: "#f8f9fa" }}>
      <Control
        label="Quel est l'organisme de saisine ?"
        required
        value={value}
        type="btnList"
        dataIndex="id"
        dataLabel="name"
        datas={availableOrganizations}
        change={onChange}
        btnInline
      />
    </div>
  );
};

export default OrganizationSelector;
